import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faSlidersH } from '@fortawesome/free-solid-svg-icons'

import SearchLocationModal from '../../components/search-location-modal'
import { handleChange, handleFilters, clearFilters } from '../../../store/actions/provider'
import Filter from './Filter'

export default function Location() {
  const [openLocationModal, setOpenLocationModal] = useState(false)
  const dispatch = useDispatch()
  const { provider } = useSelector(state => state)
  const { selectedCity, companies, filters, openFilterModal } = provider

  const filterCount = filters.branchs.length + filters.segments.length + filters.services.length

  const handleSelectedCity = city => {
    dispatch({ type: 'HANDLE_CHANGE_CITY', payload: city })
    setOpenLocationModal(false)
  }

  const handleApplyFilters = () => {
    if (filterCount === 0) {
      return toastr.warning('Por favor, selecione ao menos um filtro para prosseguir.')
    }

    dispatch(handleChange(false, 'openFilterModal'))
    dispatch(handleFilters(companies, filters))
  }

  const handleClearFilters = () => {
    dispatch(clearFilters())
  }

  const closeFilterModal = () => dispatch(handleChange(false, 'openFilterModal'))

  return (
    <div className='cp-toolbar'>
      <div className='cp-container cp-toolbar-inner'>
        <button type='button' className='cp-city' onClick={() => setOpenLocationModal(true)}>
          <FontAwesomeIcon icon={faMapMarkerAlt} aria-hidden='true' />
          <span>
            {selectedCity?.Name
              ? <>Você está em <strong>{selectedCity.Name}, {selectedCity?.States.Initials}</strong></>
              : 'Escolha a cidade'}
          </span>
        </button>
        <button type='button' className='cp-filters-button' onClick={() => dispatch(handleChange(true, 'openFilterModal'))}>
          <FontAwesomeIcon icon={faSlidersH} aria-hidden='true' />
          Filtros
          {filterCount > 0 && <span className='cp-badge'>{filterCount}</span>}
        </button>
      </div>

      {openLocationModal &&
        <SearchLocationModal
          show={openLocationModal}
          onHide={() => setOpenLocationModal(false)}
          onCancel={() => setOpenLocationModal(false)}
          onSelectCity={handleSelectedCity}
        />
      }

      {openFilterModal &&
        <Modal
          show={openFilterModal}
          onHide={closeFilterModal}
          dialogClassName='cp-filter-dialog'
          aria-labelledby='cp-filter-title'
        >
          <Modal.Header closeButton>
            <Modal.Title id='cp-filter-title'>Filtros</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Filter />
          </Modal.Body>
          <Modal.Footer className='cp-filter-footer'>
            <button type='button' className='cp-btn cp-btn-secondary' onClick={handleClearFilters}>
              Limpar
            </button>
            <button type='button' className='cp-btn cp-btn-primary' onClick={handleApplyFilters}>
              Aplicar filtros
            </button>
          </Modal.Footer>
        </Modal>
      }
    </div>
  )
}
